import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import SpectatorsMainHeader from 'app/components/spectators/SpectatorsMainHeader';
import {useDispatch} from 'react-redux';
import LeagueSpectatorsHeader from 'app/components/spectators/LeagueSpectatorsHeader';
import LeagueTableRow from 'app/components/spectators/LeagueTableRow';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {LoadingIndicator, LOADING_MESSAGE} from '@fupa/fupa-uikit';
import {fetchLeagueSpectators} from 'app/routes/league/LeagueSpectatorsPageActions';
import {LeagueSpectatorsPageReducer} from 'app/routes/league/LeagueSpectatorsPageReducer';
import {AdSlot} from 'app/components/ads/AdSlot';
import {useParams} from 'react-router';
import {useRestoreData, useFetchData, useDataFetchFinished} from 'app/hooks/dataHooks';

const LeagueSpectatorsPage = () => {
  const {restoredData} = useRestoreData('LeagueSpectatorsPage');

  const {leagueSlug, seasonSlug} = useParams();
  const dispatchRedux = useDispatch();
  const initialState = restoredData ?? {
    metaLeague: {},
    items: [],
    isFetching: false,
  };
  const [state, dispatch] = useReducer(LeagueSpectatorsPageReducer, initialState);
  const loadData = () => fetchLeagueSpectators(leagueSlug, seasonSlug, dispatchRedux)(dispatch, state);

  const {items, isFetching, metaLeague} = state;
  useFetchData(state, loadData, 'LeagueSpectatorsPage');
  const loadingDataFinished = useDataFetchFinished(isFetching);

  const headerParentName =
    seasonSlug && metaLeague.season ? `${metaLeague.name} ${metaLeague.season.name}` : metaLeague.name;

  const districtName = metaLeague?.district?.name ?? '';
  const title = `Zuschauer - ${headerParentName} - ${districtName}${TITLE_POSTFIX}`;
  const robots = metaLeague.active ? 'index, follow' : 'noindex, follow';
  const meta = [
    {
      name: 'description',
      content: `Die aktuelle Zuschauerstatistik mit sämtlichen detaillierten Zahlen der ${headerParentName} - Kreis ${districtName}.`,
    },
    {
      name: 'robots',
      content: robots,
    },
  ];

  let spectators = 0;
  let matches = 0;
  const tableRows = items.map((team, index) => {
    spectators += team.total;
    matches += team.matches;
    return team.team ? <LeagueTableRow key={team.team.id} team={team} index={index} /> : null;
  });

  let adUnit = null;
  if (loadingDataFinished) {
    if (items.length > 0) {
      tableRows.length > 4 ? tableRows.splice(5, 0, <AdSlot key='Content_1' adUnit='Content_1' />) : null;
    }
    // Place ad units if content length is not long enough
    // use same key name to get console errors if container is created twice because this would cause too many ad bidder request
    adUnit = !tableRows.length || tableRows.length <= 4 ? <AdSlot key='Content_1' adUnit='Content_1' /> : null;
  }

  let totalSpectators = spectators;
  const avgSpectators = spectators / matches;
  const content = isFetching ? <LoadingIndicator message={LOADING_MESSAGE.loadingData} /> : tableRows;

  return (
    <ContentAdDesktop noTabs top='4.5rem'>
      <Helmet title={title} meta={meta} />
      <SpectatorsMainHeader spectators={totalSpectators} avgSpecs={avgSpectators} />
      <LeagueSpectatorsHeader />
      {content}
      {adUnit}
    </ContentAdDesktop>
  );
};

export default LeagueSpectatorsPage;
